import SectionHeading from "./SectionHeading";
import { glossaryList } from "@/mocks/content";

export default function Glossary() {
  return (
    <section id="glossary" className="scroll-mt-20 bg-background-100 px-4 md:px-8 py-16 md:py-24">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          eyebrow="Glossary"
          title="常见名词小词典"
          desc="查老片时经常遇到的一些说法，先弄清楚含义，再去看片单与排片会更顺畅。"
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {glossaryList.map((item) => (
            <div
              key={item.term}
              className="rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                  <i className="ri-book-open-line text-base" />
                </span>
                <h3 className="font-heading text-base font-semibold text-foreground-950">
                  {item.term}
                </h3>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                {item.meaning}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}